import React, { useEffect, useState } from 'react';

import {
  Button,
  DialogTitle,
  DialogContent,
  Dialog,
  DialogActions,
} from '@mui/material';

import Page from 'components/Page';

import {
  browserWarningDialog,
  browserWarningDialogContent,
  browserWarningDialogTitle,
} from './styles';

const StorageGuard = ({ children }: { children: React.ReactNode }) => {
  const [isChecked, setIsChecked] = useState(false);
  const [isStorageAvailable, setIsStorageAvailable] = useState(false);

  /**
   * Checks if the browser supports Storage by attempting to set and remove a test item.
   * Sets the state `isStorageAvailable` to false if an error is caught.
   * Sets the state `isChecked` to true after executing.
   * @function
   * @returns {void}
   */
  const checkStorage = () => {
    try {
      const testKey = '__test__';
      localStorage.setItem(testKey, testKey);
      localStorage.removeItem(testKey);
      setIsStorageAvailable(true);
    } catch (e) {
      setIsStorageAvailable(false);
    } finally {
      setIsChecked(true);
    }
  };

  const redirectToExternalBrowser = () => {
    const currentUrl = window.location.href.replace('https://', '');

    window.location.assign(
      `intent://${currentUrl}#Intent;scheme=https;package=com.android.chrome;end`,
    );
  };

  useEffect(() => {
    // check storage on mount
    checkStorage();
  }, []);

  if (!isChecked) {
    return null;
  }

  if (!isStorageAvailable) {
    return (
      <Page useHeader>
        <Dialog
          open={true}
          onClose={redirectToExternalBrowser}
          className={browserWarningDialog}
        >
          <DialogTitle>
            <div className={browserWarningDialogTitle}>
              Browser yang Kamu Gunakan <br /> Tidak Bisa Buka GrabModal
            </div>
          </DialogTitle>
          <DialogContent>
            <div className={browserWarningDialogContent}>
              Coba buka aplikasi GrabModal di aplikasi browser lain di HP kamu,
              ya!
            </div>
          </DialogContent>
          <DialogActions style={{ padding: '20px 24px 20px 24px' }}>
            <Button
              onClick={redirectToExternalBrowser}
              variant='contained'
              color='primary'
              fullWidth
            >
              Mengerti
            </Button>
            <br />
            <br />
          </DialogActions>
        </Dialog>
      </Page>
    );
  }

  return children;
};

export default StorageGuard;
